export enum Application_Type{
    Firefighter = 1,
    Administration = 2,
    Both = 3
}